import { ReactNode } from 'react';
import { useAppSelector } from 'store/hooks';
import { selectPermissionCodes } from 'store/features/permissions/selector';

type PermissionHandlerProps = {
  requiredPermissionCodes: string[];
  children: ReactNode;
};

const PermissionHandler = ({ requiredPermissionCodes, children }: PermissionHandlerProps) => {
  const permissionCodes = useAppSelector(selectPermissionCodes);

  const isShow =
    requiredPermissionCodes.some((requiredPermissionCode) => permissionCodes.includes(requiredPermissionCode)) ||
    !requiredPermissionCodes.length;

  return isShow ? <>{children}</> : null;
};

export default PermissionHandler;
